import type { MinifiedTask, QuestionnaireRevisionContext, QuestionnaireSystemTaskData } from '@gcv/shared';
import { TaskInternalType } from '@gcv/shared';

type RevisionWithCompletion = QuestionnaireRevisionContext & { completed_on?: string };

// Match a revision task to its revision_history entry by closest requested_on vs
// task.date_created — the BE creates the task at the same time it appends the
// revision, so timestamps line up. Returns null if the history is empty.
const findRevisionForTask = (
  task: MinifiedTask,
  history: RevisionWithCompletion[]
): RevisionWithCompletion | null => {
  if (history.length === 0) return null;
  const taskCreatedAt = new Date(task.date_created).getTime();
  return [...history]
    .map((rev) => ({
      rev,
      delta: Math.abs(new Date(rev.requested_on).getTime() - taskCreatedAt)
    }))
    .sort((a, b) => a.delta - b.delta)[0].rev;
};

export const getTaskCompletedOn = (task: MinifiedTask): string | undefined => {
  if (task.internal_type !== TaskInternalType.REVISE_QUESTIONNAIRE) {
    return task.completed_on;
  }

  const data = task.data as QuestionnaireSystemTaskData | undefined;
  const history = (data?.questionnaire?.revision_history ?? []) as RevisionWithCompletion[];

  const matched = findRevisionForTask(task, history);
  if (matched && matched.completed_on && matched.completed_on.length > 0) {
    return matched.completed_on;
  }
  return task.completed_on;
};
